import OutreachBase from "./OutreachBase";
import { PIPELINE, STAGE_LABEL, STAGE_INDEX, stageFarge } from "./eventosUtils";

export function gruppeFor(sp) {
  if (sp.stage === "declined" || sp.signal === "no") return "no";
  if (sp.signal === "maybe" || sp.stage === "interested") return "maybe";
  if (sp.signal === "yes" || (STAGE_INDEX[sp.stage] ?? 0) >= 5) return "yes";
  if ((STAGE_INDEX[sp.stage] ?? 0) >= 2) return "venter";
  return "ikke_kontaktet";
}

const CFG = {
  testPrefix: "outreach",
  stages: PIPELINE,
  stageLabel: STAGE_LABEL,
  stageIndex: STAGE_INDEX,
  stageFarge,
  gruppeFor,
  jaStage: "verbal",
  gjenaapneStage: "outreach_sent",
  gjenaapneLabel: "Kontaktet",
  avslagsgrunner: ["Honorar", "Dato passer ikke", "Tema passer ikke", "Fikk ikke svar", "Annet"],
  navn: (sp) => sp.person?.name,
  undertekst: (sp) => [sp.person?.title, sp.person?.org].filter(Boolean).join(" · ") || "—",
  sokFelt: (sp) => [sp.person?.name, sp.person?.title, sp.person?.org],
  gruppeSum: null,
  tomTekst: "Ingen speakers i pipelinen ennå",
};

export default function OutreachListe({ speakers, members = [], onOpen, onPatch, onBulkPatch, onBulkDelete, fokus, onFjernFokus }) {
  return <OutreachBase items={speakers} members={members} onOpen={onOpen} onPatch={onPatch} onBulkPatch={onBulkPatch} onBulkDelete={onBulkDelete} fokus={fokus} onFjernFokus={onFjernFokus} cfg={CFG} />;
}
